import { render, staticRenderFns } from "./TQM.vue?vue&type=template&id=0d600b09"
import script from "./TQM.vue?vue&type=script&lang=js"
export * from "./TQM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports